import { render, staticRenderFns } from "./deleteItrModal.vue?vue&type=template&id=5608800e&scoped=true&"
import script from "./deleteItrModal.vue?vue&type=script&lang=js&"
export * from "./deleteItrModal.vue?vue&type=script&lang=js&"
import style0 from "./deleteItrModal.vue?vue&type=style&index=0&id=5608800e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608800e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5608800e')) {
      api.createRecord('5608800e', component.options)
    } else {
      api.reload('5608800e', component.options)
    }
    module.hot.accept("./deleteItrModal.vue?vue&type=template&id=5608800e&scoped=true&", function () {
      api.rerender('5608800e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/roadmap/deleteItrModal.vue"
export default component.exports